import { render, staticRenderFns } from "./AddTable.vue?vue&type=template&id=1e9cc1e1&"
import script from "./AddTable.vue?vue&type=script&lang=js&"
export * from "./AddTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports